<template>
  <div>

    <div id="scrollContainer" ref="scrollContainer"
      class="relative bg-[#FDF9EE] [word-break:break-word;] overflow-x-hidden" :class="[
        $route.path === '/dashboard' ? 'laptop:h-[100dvh] laptop:overflow-y-hidden' : 'laptop:min-h-[100dvh]',
        $route.path === '/thankyou' && isShowHeader ? 'laptop:!h-[115dvh] largeDesktop:!h-[100dvh]' : '',
        isMobile ? 'min-h-screen overflow-y-visible' : ''
      ]" :style="!isMobile ? 'height: 100dvh;' : ''">
      <FLoader />
      <!-- <headerNew v-if="isFromMobile != 1" /> -->
      <headerUpdated v-if="isFromMobile != 1 && !SSOLogin" />
      <!-- class="mobile:px-3 mobile:pt-28 laptop:pt-24 desktop:pt-16 largeDesktop:pt-20 largeDesktop:pl-10 laptop:pr-5 largeDesktop:pr-7 pb-4 relative" -->
      <div class="relative flex flex-col min-h-full" :class="{
        '!pt-[50px]': isFromMobile == 1,
        'laptop:max-w-full desktop:!container mobile:max-w-full laptop:!mx-auto laptop:p-0 mobile:px-[15px] laptop:px-[30px] desktop:px-[15px] mobile:pt-[70px] tablet:pt-[85px] laptop:pt-[100px] laptop:!container': $route.path !== '/dashboard',
        // 'laptop:!pt-[10px] largeDesktop:!pt-0' : $route.path == '/dashboard'
      }">

        <div v-if="$route.path !== '/thankyou' && $route.path !== '/faq'" class="order-3">
          <div v-if="$route.path === '/dashboard'">
          </div>
          <div v-else
            class="animate-float relative laptop:absolute mobile:bottom-0 mobile:z-[99] laptop:z-auto laptop:bottom-[0px] left-0 laptop:-left-[0px] desktop:-left-[40px] largeDesktop:-left-[140px] mobile:mt-[30px] tablet:mt-[40px] mobile:mx-auto mobile:w-[300px] tablet:w-[350px] laptop:w-[320px] desktop:w-[330px] largeDesktop:w-[550px]"
            :class="$route.path.includes('/claim/create') ? 'mobile:!z-auto' : ''">
            <img src="../../assets/images/myHappyHomeFamilyImg.png" alt="Body Bg"
              class="w-full object-cover block transform transition-transform duration-[500ms] hover:scale-[1.02]">
          </div>
        </div>
        <GlobaldashboardHead v-if="!SSOLogin" />
        <!-- {{ isCollapsed }} -->
        <div v-if="user" :class="$route.path == '/dashboard' ? '!hidden' : ''">
          <paymentFailed />
        </div>

        <WelcomeCard v-if="$route.name !== 'dashboard' && $route.path !== '/thankyou'"
          :heading="'Welcome ' + (user ? user.user.full_name : '')"
          :text="'Let’s make today productive and achieve some great results'" />

        <div :class="[
          'flex flex-grow items-start gap-5',
          ($route.path === '/purchases' || $route.path === '/billings/transactions')
            ? 'laptop:mt-[50px]'
            : ''
        ]">
          <!-- mt-10  -->
          <div class="flex items-start largeDesktop:gap-5 laptop:gap-4 w-full transition duration-800" :class="{
            '!gap-0': $route.name === 'globalSearch' && isCollapsed
          }">
            <SidebarNavigation
              v-if="isSideMenuShow && !isMobile && $route.path !== '/thankyou' && $route.path !== '/faq'"
              @sidebar-collapse="handleSidebarCollapse"
              class="!w-auto transition duration-800 flex-shrink-0 mobile:hidden laptop:flex" :class="{
                '!w-0': $route.name === 'globalSearch' && isCollapsed
              }" />
            <!-- <sidebar class="!w-auto transition duration-800 flex-shrink-0 mobile:hidden laptop:flex" /> -->

            <!-- Main Content -->
            <div class="flex-1 min-w-0 transition duration-1500" :class="{
              'w-[calc(100vw-320px)] mx-auto': !isCollapsed,  // 100vw - 64 (16rem = 256px)
              'mobile:w-auto mobile:flex-1 desktop:w-[calc(100vw-500px)] largeDesktop:w-[calc(100vw-700px)] mx-auto desktop:flex-none': $route.name === 'globalSearch' && isCollapsed,
            }">
              <!-- <dashboard /> -->
              <router-view ref="page"></router-view>
            </div>
          </div>
        </div>
      </div>
      <FooterPartial class="mt-auto" v-if="$route.name !== 'dashboard' && !SSOLogin" />
      <footertermsandConditions v-else-if="SSOLogin" />
    </div>
    <MyDialog />
    <ConfirmDialog />
  </div>
</template>

<script>
import {
  mapGetters, mapActions
} from "vuex";
// import headerNew from "../../components/layouts/header/header_new.vue";
import headerUpdated from "./header/header.vue";
import GlobaldashboardHead from "../globaldashboardHead.vue";
import SidebarNavigation from "../sidebarNavigation.vue";
import WelcomeCard from "../welcomeCard.vue";
import FooterPartial from "./footer/FooterPartial.vue";
// import sidebar from "../nest_components/omega_sidebar/sidebar.vue";
// import dashboard from "../../views/dashboard/dashboard.vue";
import { useToast } from "vue-toastification";
import router from "../../router";
// import cookiesConsent from "../nest_components/cookiesConsent.vue";
import footertermsandConditions from "../../components/layouts/footer/terms-and-conditions-footer.vue";
import paymentFailed from "../../components/partialComponent/paymentFailedHeader.vue";

const toast = useToast();

export default {
  name: "Layout",

  components: {
    // headerNew,
    GlobaldashboardHead,
    WelcomeCard,
    SidebarNavigation,
    FooterPartial,
    headerUpdated,
    footertermsandConditions,
    paymentFailed
    // cookiesConsent
    // sidebar
    // dashboard
  },

  data() {
    return {
      td: '',
      user: JSON.parse(localStorage.getItem('user')) ?? null,
      isCollapsed: false, // or true, depending on your default state
      isMobile: window.innerWidth < 1275 ? true : false,
      SSOLogin: JSON.parse(localStorage.getItem('SSOLogin')) ?? null,
      isShowHeader: false
    };
  },

  computed: {
 ...mapGetters([
      "failedInvoices",
    ]),
    isFromMobile() {
      return this.$route.query.is_from_mobile ?? 0;
    },


    isSideMenuShow() {
      return this.$route.name != 'dashboard';
    }

  },

  mounted() {
    window.addEventListener('focusin', this.handleGlobalFocus);
    window.scrollTo(0, 0);
  },
  beforeUnmount() {
    window.removeEventListener('focusin', this.handleGlobalFocus);
  },

  watch: {
    '$route'() {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollTop = 0;
      }
      window.scrollTo(0, 0);
    },
    failedInvoices: function (data) {
        if (this.failedInvoices.invoices.length > 0) {
            this.isShowHeader = true
        }
        else {
            this.isShowHeader = false
        }
    },
  },
  methods: {

    handleSidebarCollapse(isCollapsed) {
      this.isCollapsed = isCollapsed;
    },

    handleGlobalFocus(event) {
      if (this.isMobile) {
        const target = event.target;
        if (['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName) || target.closest('.stripe-element-container')) {
          setTimeout(() => {
            target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 300);
        }
      }
    }


  }
};
</script>
